import { currencySymbol, currencyTrails } from "./subscription";

/**
 * The SMS centre's vocabulary. Every value mirrors a backend enum that is
 * stored as an int (SmsEnums.cs, NotificationEnums.cs, SmsDTOs.cs), so the
 * numbers are permanent — change a name freely, never a number.
 */

/** NotificationKind — what a message was about. */
export const NotificationKind = {
  CONFIRMATION: 0,
  REMINDER: 1,
  CHANGE: 2,
  CANCELLATION: 3,
};

/** SmsActivityType — one line of the history. */
export const SmsActivityType = {
  PURCHASE: 0,
  MESSAGE: 1,
};

/** SmsMessageStatus — where one message is. */
export const SmsMessageStatus = {
  QUEUED: 0,
  ACCEPTED: 1,
  SENT: 2,
  DELIVERED: 3,
  FAILED: 4,
};

/** SmsCreditSource — which pool paid for a message. */
export const SmsCreditSource = {
  INCLUDED: 0,
  PURCHASED: 1,
  MIXED: 2,
  OWN_NUMBER: 3,
};

/** SmsReplyAction — what the customer's answer did. */
export const SmsReplyAction = {
  NONE: 0,
  CONFIRMED: 1,
  CANCELLED: 2,
  REFUSED: 3,
};

/** Translation keys under Dashboard.Sms, by value. */
export const NotificationKindKeys = {
  [NotificationKind.CONFIRMATION]: "Dashboard.Sms.kinds.confirmation",
  [NotificationKind.REMINDER]: "Dashboard.Sms.kinds.reminder",
  [NotificationKind.CHANGE]: "Dashboard.Sms.kinds.change",
  [NotificationKind.CANCELLATION]: "Dashboard.Sms.kinds.cancellation",
};

export const SmsMessageStatusKeys = {
  [SmsMessageStatus.QUEUED]: "Dashboard.Sms.status.queued",
  [SmsMessageStatus.ACCEPTED]: "Dashboard.Sms.status.accepted",
  [SmsMessageStatus.SENT]: "Dashboard.Sms.status.sent",
  [SmsMessageStatus.DELIVERED]: "Dashboard.Sms.status.delivered",
  [SmsMessageStatus.FAILED]: "Dashboard.Sms.status.failed",
};

export const SmsReplyKeys = {
  [SmsReplyAction.CONFIRMED]: "Dashboard.Sms.reply.confirmed",
  [SmsReplyAction.CANCELLED]: "Dashboard.Sms.reply.cancelled",
  [SmsReplyAction.REFUSED]: "Dashboard.Sms.reply.refused",
};

/** The billing page's SMS tab — under billing, so it inherits that item's access. */
export const SMS_CENTER_PATH = "/dashboard/billing/sms";

/**
 * Price per SMS of a package, in the package's currency — the "€0.0556 / SMS"
 * line under each one. Four decimals, because at two every package reads the
 * same.
 */
export const pricePerSms = (pkg) =>
  pkg && pkg.quantity > 0 ? pkg.priceCents / 100 / pkg.quantity : 0;

/** `pricePerSms` with its currency, written the way that currency is written. */
export const formatPricePerSms = (pkg) => {
  const amount = pricePerSms(pkg).toFixed(4);
  const symbol = currencySymbol(pkg?.currency);
  return currencyTrails(pkg?.currency) ? `${amount} ${symbol}` : `${symbol}${amount}`;
};
